module.exports = __webpack_public_path__ + "static/media/nationwide.c712facb.webp";